<template>
	<div
		class="am-list"
		:class="[
			`am-list--${size}`,
			`am-list--${theme}`,
			{
				'is-inline': inline,
				'is-dark': dark
			}
		]"
	>
		<am-text
			v-for="(item, key) in items"
			class="am-list__item"
			type="nav"
			:class="{'is-active': value == key	}"
			@click.native="$emit('input', key)"
		> <!-- @click.native="$emit('input', key)" -->
			<span>
				<router-link style="color: #99887F;" :to="{path: '/home/#' + key}"  class="menu-item text-decoration-none">{{ item }}</router-link>
			</span>
		</am-text>
	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMIcon from '@/components/atoms/AMIcon'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
		'am-icon': AMIcon,
	},

	props: {
		value: {
			type: String|Number,
			default: undefined
		},
		items: {
			type: Object,
			default: () => ({
				'about': 'Sobre',
				'gallery': 'Galeria',
				// 'parque-das-americas': 'Parque das Americas',
				'entertainment': 'Ambientes e Lazer',
				'chill': 'Viva com Tranquilidade',
				'safety': 'Segurança',
				'lifestyle': 'Qualitare e Estilo de Vida',
				'sustainability': 'Sustentabilidade',
				'team': 'Equipe',
				'book': 'Vídeo e Book Digital',
				'parque-das-americas': 'Parque das Américas',
				'location': 'Localização',
				'contact': 'Contato'
			})
		},
		inline: {
			type: Boolean,
			default: false
		},
		dark: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'md' // sm | md | lg
		},
		theme: {
			type: String,
			default: 'primary' // primary | default
		}
	},

	methods: {
		/* changingCurrent() {
			vm.$store.commit('navigation/setCurrent', "blog");
			this.$router.go();
			console.log("method foi chamado");
		} */
	},

	mounted() {
		TweenMax.staggerFrom(this.$el.querySelectorAll('.am-list__item'), .4, {
			delay: .2,
			opacity: 0,
			y: "-=30",
			ease: Power2.easeInOut
		}, 0.05)
	}
}
</script>

<style lang="scss">
.menu-item{
	color: #99887F;
	text-decoration: none;
}
.am-list{
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	&__item{
		padding: 16px 5px 0 5px;
		margin: 16px 0;
		cursor: pointer;
		box-sizing: border-box;
		flex: 0 25%;
		position: relative;
		opacity: 1;
		span{
			position: relative;
			&:before{
				content: "";
				height: 3px;
				width: 0px;
				background: #99887F;
				position: absolute;
				bottom: -8px;
				left: 0;
				transition: .3s $easeInOutQuad;
			}
		}
		&:hover,
		&.is-active{
			span{
				&:before{
					width: 100%;
				}
			}
		}
	}
	&__arrow{
		display: inline-block;
		transform: translateY(1px);
	}

	@include grid-media($smartphone-grid) {
		.am-list{
			&__item{
				padding: 8px 16px;
				margin: 0;
				max-width: 50%;
				flex: 0 50%;
				text-align: center;
				span{
					&:before{
						left: 50%;
						transform: translateX(-50%);
					}
				}
			}
		}
	}

	@include grid-media($tablet-grid) {
		.am-list{
			&__item{
				padding: 8px 16px;
				margin: 0;
				max-width: 50%;
				flex: 0 50%;
				text-align: center;
				span{
					&:before{
						left: 50%;
						transform: translateX(-50%);
					}
				}
			}
		}
	}

}
</style>
